import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Container,
  Divider,
  Grid,
  InputLabel,
  makeStyles,
  Typography,
} from "@material-ui/core";

import { PAGES } from "..";
import { api } from "../../services/api";
import { LogoText } from "../../components/logoText";
import { TextInput } from "../../components/base/TextInput";
import ResetPasswordImg from "../../assets/images/Registration/bottom_illustration.svg";
import { FooterReset } from "../../components/footerReset";
import { Button, TextButton } from "../../components/base/Button";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  logo: {
    padding: theme.spacing(5),
    textAlign: "center",
  },
  title: {
    marginTop: theme.spacing(12),
    fontSize: "36px",
  },
  subtitle: {
    marginBottom: theme.spacing(6),
    fontWeight: "300",
    lineHeight: "45px",
    display: "flex",
    justifyContent: "center",
  },
  youremail: {
    marginLeft: "15%",
  },
  input: {
    width: "70%",
  },
  inputLabel: {
    fontSize: "14px",
    alignSelf: "left",
  },
  groupBtn: {
    marginTop: theme.spacing(6),
  },
  resetImgstyle: {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    top: "107px",
    marginTop: "2%",
  },
}));

export const ForgetPasswordPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async () => {
    setErrors({});
    const errors = {};
    if (!email) {
      errors["email"] = "Please enter email";
    }
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }
    setLoading(true);
    api
      .post("/auth/restore-pass/", { email })
      .then((res) => {
        if (res.status === 200) {
          setEmail("");
          navigate(PAGES.emailSuccess, { replace: true });
        }
      })
      .catch(() => {
        setErrors({
          email: "Email is not valid",
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className={classes.root}>
      <div className={classes.logo}>
        <LogoText />
      </div>
      <Divider />

      <Typography className={classes.title} variant="h4" align="center">
        Forgot your password?
      </Typography>
      <Container maxWidth="xs">
        <Grid container direction="column">
          <Grid alignItems="center">
            <Typography className={classes.subtitle} variant="h4">
              We’re here to help
            </Typography>
          </Grid>
          <div className={classes.youremail}>
            <InputLabel className={classes.inputLabel}>Your email:</InputLabel>
          </div>
          <TextInput
            id="email-input"
            fullWidth
            rootStyle={classes.input}
            onChange={(v) => setEmail(v)}
            error={errors.email}
            value={email}
            onFocus={() => setErrors({ ...errors, email: null })}
          />

          <Grid
            className={classes.groupBtn}
            container
            justifyContent="space-evenly"
            alignItems="center"
          >
            <Button
              id="reset-password"
              rootStyle={classes.loginBtn}
              text="RESET PASSWORD"
              loading={loading}
              onClick={handleResetPassword}
            />
            <TextButton
              text={"cancel"}
              onClick={() => navigate(PAGES.login, { replace: true })}
            />
          </Grid>
        </Grid>
      </Container>
      <div>
        <div className={classes.resetImgstyle}>
          <img src={ResetPasswordImg} alt="" />
        </div>
        <div>
          <FooterReset />
        </div>
      </div>
    </div>
  );
};
